export enum AnchorRelationship {
  /**  Links to an unendorsed document, like a paid link.
  ("nofollow" is used by Google, to specify that the Google search spider should not follow that link)*/
  NoFollow = "nofollow",
}

export enum AnchorTarget {
  Blank = "_blank",
}
